import { RangeInput } from 'react-instantsearch-dom'

export default function Price() {
    return (
        <div className="mb36">
            <div className="ais-Heading mb18">Kaina</div>
            <RangeInput
                attribute="price_from"
                translations={{
                    submit: 'Filtruoti',
                    separator: 'iki'
                }}
            />
        </div>
    )
}
